<template>
  <div class="main" @click="contentClick">
    <slot :open="imClick">
      <template v-if="showCustomerService">
        <div v-if="isBtnStyle" class="btn-style" v-fastclick="()=>{imClick()}">联系客服</div>
        <template v-else>
          <div v-if="igc_from !== 'miniProgram'" :class="unfold?'block':'block left_over'" v-fastclick="()=>{imClick()}">
            <i class="icon im"></i>
            <h4 v-if="unfold" class="name">客服</h4>
          </div>
        </template>
      </template>
    </slot>
  </div>
</template>

<script>
import { getUser } from '@utils/auth';
import { env, LogTrack, JS2Native } from '@utils';
import { jumpToService } from '@utils/common';

export default {
  props: {
    isBtnStyle: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    goodsDetail: {
      type: Object
    },
    userReallyOnline: Boolean,
    isShowShare: {
      type: [Boolean, Number],
      default() {
        return true;
      }
    },
    qimoType: {
      type: String,
      default: ''
    },
    qimoParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    let { itemid, igc_from } = this.$route.query;
    if (igc_from === 'xxx') { igc_from = undefined }

    return {
      itemid,
      unfold: true,
      userInfo: null,
      igc_from,
      showCustomerService: true,
    };
  },
  created() {
    if (env.isWeChat) {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          this.showCustomerService = false;
        } else {
          this.initIM();
        }
      });
    } else {
      this.initIM();
    }
  },
  methods: {
    initIM() {
      this.userInfo = getUser();

      if (env.isHarmonyApp || this.qimoType == 'h5') {
        return;
      }

      if (this.userInfo && this.igc_from !== 'miniProgram' && this.$route.query.webchat !== '0') {
        window.qimoClientId = {
          userId: `${JSON.parse(localStorage.getItem('IGetCool-USER-Info')).uid}`, // 自定义用户的唯一id，不能传空字符串、null、中文，id由字母大小写、数字及'-'和 '_'组成
          priority: false, // 是否优先进线设置，非必填，值为boolean类型的true或false
          nickName: `${JSON.parse(localStorage.getItem('IGetCool-USER-Info')).phone}`, // 自定义用户昵称，定义用户昵称则userId必传
          customField: { // 扩展字段，json对象，对象中的key-value都自定义
            '手机号': `${JSON.parse(localStorage.getItem('IGetCool-USER-Info')).phone}`,
            'uid': `${JSON.parse(localStorage.getItem('IGetCool-USER-Info')).uid}`,
            'channel': this.channel
          }
        };
        this.$nextTick(() => {
          if (document.querySelector('#talk_tool_qimo')) { return }
          let secScript = document.createElement('script');
          secScript.setAttribute('type', 'text/javascript');
          secScript.setAttribute('id', 'talk_tool_qimo');
          secScript.setAttribute('src', 'https://webchat.7moor.com/javascripts/7moorInit.js?accessId=7b3019f0-c57b-11e9-9f01-8969b6bbf727&autoShow=false&language=ZHCN');
          secScript.setAttribute('async', 'async');
          document.body.insertBefore(secScript, document.body.lastChild);
        });
      }
    },

    contentClick(e) {
      if (!this.unfold) {
        this.$emit('clickTool');
      }
    },

    // 打开客服
    // @aigc:start 2024/07/26-17:02
    toIM() {
      if (env.isHarmonyApp || this.qimoType == 'h5') {
        jumpToService({ channel: this.igc_from, otherParams: this.qimoParams });
        return;
      }
      qimoChatClick();
    },
    // @aigc:end 2024/07/26-17:02

    imClick() {
      if (this.unfold) {
        this.$emit('goToIM');
      }

      if (this.unfold) {
        if (this.userInfo) {
          this.toIM();
        } else {
          if (env.isApp) {
            this.$emit('toAppLogin');
          } else {
            const search = location.search;
            const redirect = location.pathname;
            // this.$router.replace({ path: `/mall/login${search ? `${search}&` : '?'}redirect=${redirect}` });
            this.$coolDoLogin({
              stringify: true,
              oneKeyAgree: true,
              subTitle: {
                title: '该手机号将用于开通课程',
                styles: { color: '#6D6D80' }
              },
              loginTxt: '立即登录',
              showProtocol: true,
              channel: this.$route.query.igc_from || '',
              title: '登录/注册少年得到' }).then((res) => {
              if (res.code === 10000) {
                location.reload();
              }
            });
          }
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
  *
    box-sizing border-box

  .main
    display flex
    align-items center

    height .56rem
    padding 0 .04rem 0 .12rem
    border-radius 1rem 0 0 1rem
    transition width .5s
    -webkit-transition width .5s
    z-index 2000
    .block
      display flex
      flex-direction column
      align-items center
      justify-content center

      &:not(:first-child)
        margin-left .12rem

      &.left_over
        &:not(:first-child)
          margin-left -.05rem !important

      .icon
        box-sizing border-box
        display inline-block
        width 20px
        height 20px
        background-size 20px 20px
        background-position center
        background-repeat no-repeat
        padding 6px
        &.im
          background-image image-set(url(https://coolcdn.igetcool.com/p/2023/9/d02e3d2da1106ecb538af037682f7eff.png?_40x42.png) 2x)
          background-image -webkit-image-set(url(https://coolcdn.igetcool.com/p/2023/9/d02e3d2da1106ecb538af037682f7eff.png?_40x42.png) 2x)

      .name
        font-size 12px
        font-weight 500
        line-height 14px
        color #41414D
    .btn-style {
      display: inline-block;
      width: 84px;
      height: 35px;
      border-radius: 18px;
      box-sizing: border-box;
      border: 1px solid #979797
      text-align: center;
      line-height: 35px;
      margin-right: 10px;
      color: #41414D;
      font-size: 14px;
    }
</style>
